module.exports = __webpack_public_path__ + "static/media/Balagansky.c4307612.png";